// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   Box,
//   CircularProgress,
//   Typography,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Grid,
//   Checkbox,
//   FormControlLabel,
//   Button,
//   Snackbar,
//   Alert,
//   Select,
// } from "@mui/material";
// import HeaderBannerPage from "../components/HeaderBannerPage";
// //import { fetchTodayAttendance } from "../actions/TodayAction";
// import { FiChevronUp, FiChevronDown } from "react-icons/fi";
// import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";
// import {
//   fetchOTtimes,
//   assignOT,
//   fetchOTjobAttendance,
//   fetchOTdetails,
// } from "../actions/OTAction";
// import { fetchLocations, assignJob, fetchJobs } from "../actions/AssignAction";
// import { useLocation } from "react-router-dom";
// //import * as XLSX from "xlsx";
// const Dropdown = ({ label, value, onChange, options, loading }) => (
//   <FormControl fullWidth>
//     <InputLabel sx={{ fontSize: { xs: "0.9rem", sm: "1rem" } }}>
//       {label}
//     </InputLabel>
//     <Select
//       value={value}
//       onChange={onChange}
//       label={label}
//       sx={{
//         fontSize: { xs: "0.85rem", sm: "1rem" },
//         borderRadius: "20px",
//         backgroundColor: "#F0F4F8",
//         boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//         "& .MuiSelect-icon": {
//           color: "#154C79",
//         },
//         "& .MuiOutlinedInput-notchedOutline": {
//           borderColor: "#154C79",
//         },
//       }}
//       MenuProps={{
//         PaperProps: {
//           sx: {
//             maxHeight: 250,
//             overflowY: "auto",
//           },
//         },
//       }}
//     >
//       {loading ? (
//         <MenuItem value="">Loading...</MenuItem>
//       ) : options.length ? (
//         options.map((option, index) => (
//           <MenuItem
//             key={index}
//             value={option.value}
//             sx={{
//               whiteSpace: "normal",
//               wordWrap: "break-word", // Prevents overflow by wrapping long words
//               padding: "7px 16px",
//               fontWeight: "400",
//               fontSize: "14px",
//               lineHeight: "1.5",
//               overflow: "hidden",
//               textOverflow: "ellipsis",
//               "&:hover": {
//                 backgroundColor: "rgba(0, 0, 0, 0.08)", // Adds hover effect for better interactivity
//               },
//               "&.Mui-selected": {
//                 backgroundColor: "rgba(0, 0, 0, 0.12)", // Changes selected background color
//               },
//             }}
//           >
//             {option.label}
//           </MenuItem>
//         ))
//       ) : (
//         <MenuItem value="">No options available</MenuItem>
//       )}
//     </Select>
//   </FormControl>
// );
// const AssignOT = () => {
//   const dispatch = useDispatch();
//   const location = useLocation();
//   const { employeeId, department, role } = location.state || {};
//   const { attendanceItems, loading } = useSelector(
//     (state) => state.otjobAttendance
//   );
//   const { timeSlots, loading: timeSlotLoading } = useSelector(
//     (state) => state.timeSlots || {}
//   );
//   const { locationValue, loading: locationLoading } = useSelector(
//     (state) => state.assignLocation || {}
//   );
//   const { loading: otAssignLoading, error } = useSelector(
//     (state) => state.assignOTpost || {}
//   );
//   const [selectedTimes, setSelectedTimes] = useState("");
//   const [selectedTimeId, setSelectedTimeId] = useState("");
//   const [selectedType, setSelectedType] = useState("");
//   const [filteredTimeSlots, setFilteredTimeSlots] = useState([]);
//   const [selectedAttendance, setSelectedAttendance] = useState({});
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarSeverity, setSnackbarSeverity] = useState("success");
//   const [selectedLocation, setSelectedLocation] = useState(role);
//   const { jobValue, loading: jobLoading } = useSelector(
//     (state) => state.assignJob || {}
//   );
//   const [Jobiwno, setSelectedJobiwno] = useState("");
//   const [selectedJobEmployees, setSelectedJobEmployees] = useState(null);
//   const [showDropdown, setShowDropdown] = useState(null); // Tracks which job dropdown is open
//   const handleJobClick = (iwNo, jobId) => {
//     if (showDropdown === iwNo) {
//       setShowDropdown(null); // Close the dropdown if the same job is clicked again
//     } else {
//       setShowDropdown(iwNo); // Open the dropdown for the selected job
//       const date = getTodayDate();
//       dispatch(fetchOTjobAttendance(date, department, selectedLocation, iwNo)); // Fetch employees for the selected job
//     }
//   };
//   const fetchAssignedEmployees = (iwNo) => {
//     // Assuming attendanceItems contains the employee list, filter them by iwNo
//     const employees =
//       attendanceItems?.filter((item) => item.iwNo === iwNo && item.selected) ||
//       [];
//     setSelectedJobEmployees(employees);
//   };
//   const handleLocationChange = (event) =>
//     setSelectedLocation(event.target.value);
//   const handleTypeChange = (event) => setSelectedType(event.target.value);

//   const getTodayDate = () => {
//     const today = new Date();
//     //today.setDate(today.getDate() - 2);
//     return today.toISOString().split("T")[0];
//   };
//   useEffect(() => {
//     const filteredSlots = timeSlots.filter(
//       (slot) => slot.Type === selectedType
//     );
//     setFilteredTimeSlots(filteredSlots);
//     setSelectedTimes("");
//   }, [selectedType, timeSlots]);
//   useEffect(() => {
//     if (employeeId && department) {
//       const date = getTodayDate();
//       //dispatch(fetchOTjobAttendance(date, department, selectedLocation,Jobiwno));
//       dispatch(fetchJobs(date, employeeId));
//       dispatch(fetchOTtimes());
//       dispatch(fetchLocations(department));
//     }
//   }, [dispatch, role, department, selectedLocation, Jobiwno, employeeId]);

//   const formatTimeTo12Hour = (time) => {
//     const [hours, minutes] = time.split(":");
//     const date = new Date();
//     date.setHours(parseInt(hours, 10));
//     date.setMinutes(parseInt(minutes, 10));
//     return date.toLocaleTimeString("en-US", {
//       hour: "numeric",
//       minute: "2-digit",
//       hour12: true,
//     });
//   };

//   const dropdownOptions = {
//     typeOptions: [...new Set(timeSlots.map((slot) => slot.Type))]
//       .map((type) => ({
//         value: type,
//         label:
//           type === "HSD"
//             ? "Company Holidays and Sunday"
//             : type === "SD"
//             ? "Saturday"
//             : type === "WD"
//             ? "Weekday"
//             : null,
//       }))
//       .filter((option) => option.label !== null),
//     timeSlotOptions: filteredTimeSlots.map((slot) => ({
//       value: `${formatTimeTo12Hour(slot.Intime)} - ${formatTimeTo12Hour(
//         slot.OutTime
//       )}`,
//       label: `${formatTimeTo12Hour(slot.Intime)} - ${formatTimeTo12Hour(
//         slot.OutTime
//       )}`,
//     })),
//     locationOptions: locationValue?.map((location) => ({
//       value: location.location,
//       label: location.locationDescription,
//     })),
//   };

//   const handleTimeChange = (event) => {
//     const selectedTimes = event.target.value;
//     const selectedTimesData = filteredTimeSlots.find(
//       (slot) =>
//         `${formatTimeTo12Hour(slot.Intime)} - ${formatTimeTo12Hour(
//           slot.OutTime
//         )}` === selectedTimes
//     );
//     if (selectedTimesData) {
//       setSelectedTimes(selectedTimes);
//       setSelectedTimeId(selectedTimesData.Id);
//     }
//   };

  

//   const handleCheckboxChange = (id) => {
//     setSelectedAttendance((prev) => {
//       const updatedState = { ...prev, [id]: !prev[id] };
//       return updatedState;
//     });
//   };
 

//   const handleSubmit = () => {
//     const selectedEmpData = attendanceItems.filter(
//       (item) => selectedAttendance[item.id]
//     );
//     if (!selectedTimes || !selectedType || selectedEmpData.length === 0) {
//       setSnackbarMessage(
//         "Please select a type, time slot, and at least one employee."
//       );
//       setSnackbarSeverity("error");
//       setSnackbarOpen(true);
//       return;
//     }
//     const getCurrentTime = () => {
//       const now = new Date();
//       return now.toTimeString().split(" ")[0];
//     };
//     const atttendOtList = selectedEmpData.map((item) => ({
//       serviceNo: item.serviceNo,
//       iwNo: item.iwNo,
//       //date: `${item.inDate} ${getCurrentTime()}`,
//       date:'2025-03-31',
//       Otid: selectedTimeId,
//       CreatedBy: employeeId,
//       location: role,
//       Emp_Location: selectedLocation,
//     }));
//     const postData = {
//       atttendOTList: JSON.stringify(atttendOtList),
//       supervisor: employeeId,
//     };
//     setIsSubmitAttempted(true);
//     dispatch(assignOT(postData));
//     setSelectedType("");
//     setSelectedTimes("");
//     setSelectedLocation(role);
//     setSelectedAttendance({});
//   };  
//   const [isSubmitAttempted, setIsSubmitAttempted] = useState(false);
//   useEffect(() => {
//     if (isSubmitAttempted && otAssignLoading === false) {
//       if (error) {
//         setSnackbarMessage(`Error: ${error.message}`);
//         setSnackbarSeverity("error");
//       } else {
//         setSnackbarMessage("Overtime assigned successfully!");
//         setSnackbarSeverity("success");
//       }
//       setSnackbarOpen(true);
//       setIsSubmitAttempted(false);
//     }
//   }, [otAssignLoading, error, isSubmitAttempted]);
//   return (
//     <Box sx={{ padding: 0, maxWidth: "95%", margin: "0 auto" }}>
//       <HeaderBannerPage />
//       <Grid container spacing={2} sx={{ marginBottom: 3 }}>
//         <Grid item xs={12} sm={4}>
//           <Dropdown
//             label="Type"
//             value={selectedType}
//             onChange={handleTypeChange}
//             options={dropdownOptions.typeOptions}
//             loading={timeSlotLoading}
//           />
//         </Grid>
//         <Grid item xs={12} sm={4}>
//           <Dropdown
//             label="Time Slots"
//             value={selectedTimes}
//             onChange={handleTimeChange}
//             options={dropdownOptions.timeSlotOptions}
//             loading={timeSlotLoading}
//           />
//         </Grid>
//         <Grid item xs={12} sm={4}>
//           <Dropdown
//             label="Location"
//             value={selectedLocation}
//             onChange={handleLocationChange}
//             options={dropdownOptions.locationOptions}
//             loading={locationLoading}
//           />
//         </Grid>
//       </Grid>
//       <Box sx={{ marginTop: 1, maxHeight: "450px", overflowY: "auto" }}>
//         {jobLoading ? (
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//               height: "200px",
//             }}
//           >
//             <CircularProgress />
//           </Box>
//         ) : (
//           <Grid container spacing={3}>
//             {jobValue.map((job) => (
//               <Grid item xs={12} sm={6} md={4} key={job.id}>
//                 <Box
//                   onClick={() => handleJobClick(job.iwNo, job.id)}
//                   sx={{
//                     padding: "20px",
//                     borderRadius: "12px",
//                     backgroundColor: "#ffffff",
//                     boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
//                     transition: "transform 0.3s ease, box-shadow 0.3s ease",
//                     cursor: "pointer",
//                     "&:hover": {
//                       transform: "translateY(-5px)",
//                       boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.2)",
//                     },
//                   }}
//                 >
//                   <Typography
//                     sx={{
//                       fontWeight: "600",
//                       fontSize: "14px",
//                       color: "#142C54",
//                       marginBottom: 1,
//                       whiteSpace: "normal",
//                       overflow: "visible",
//                       textOverflow: "clip",
//                       wordBreak: "break-word",
//                       display: "flex", // Flexbox for alignment
//                       justifyContent: "space-between", // Space between text and arrow
//                       alignItems: "center", // Center vertically
//                     }}
//                   >
//                     {job.jobDescription}
//                     {showDropdown === job.iwNo ? (
//                       <FiChevronDown size={20} color="#142C54" />
//                     ) : (
//                       <FiChevronUp size={20} color="#142C54" />
//                     )}
//                   </Typography>

//                   {/* Conditionally render dropdown */}
//                   {showDropdown === job.iwNo && (
//                     <Box
//                       sx={{
//                         marginTop: "15px",
//                         padding: "10px",
//                         borderRadius: "8px",
//                         backgroundColor: "#F9F9F9",
//                       }}
//                     >
//                       {attendanceItems?.length > 0 ? (
//                         attendanceItems.map((item) => (
//                           <Box
//                             key={item.id}
//                             sx={{
//                               padding: "12px",
//                               borderRadius: "8px",
//                               backgroundColor: "#fff",
//                               boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.05)",
//                               display: "flex",
//                               alignItems: "center",
//                               marginBottom: "8px",
//                             }}
//                           >
//                             <Box sx={{ flexGrow: 1 }}>
//                               <Typography
//                                 sx={{ fontSize: "16px", fontWeight: "500" }}
//                               >
//                                 {item.EmpName}
//                               </Typography>
//                               <Typography
//                                 sx={{ fontSize: "14px", color: "#6C757D" }}
//                               >
//                                 Service No: {item.serviceNo}
//                               </Typography>
//                             </Box>
//                             <Box
//                               sx={{ textAlign: "right", marginLeft: "auto" }}
//                             >
//                               <Typography
//                                 sx={{ color: "#239B56", fontSize: "14px" }}
//                               >
//                                 {item.inTime || "N/A"}
//                               </Typography>
//                               <Typography
//                                 sx={{ color: "#E74C3C", fontSize: "14px" }}
//                               >
//                                 {item.outTime || "N/A"}
//                               </Typography>
//                             </Box>
//                             <FormControlLabel
//                               control={
//                                 <Checkbox
//                                   checked={!!selectedAttendance[item.id]}
//                                   onChange={(event) => {
//                                     event.stopPropagation(); // Prevent dropdown from closing
//                                     handleCheckboxChange(item.id);
//                                   }}
//                                   sx={{ marginLeft: 2 }}
//                                 />
//                               }
//                               onClick={(event) => event.stopPropagation()} // Prevent parent click
//                               label=""
//                             />
//                           </Box>
//                         ))
//                       ) : (
//                         // Render "No employees assigned" message when attendanceItems is empty
//                         <Typography
//                           sx={{
//                             fontSize: "14px",
//                             color: "#6C757D",
//                             textAlign: "center",
//                           }}
//                         >
//                           No employees assigned
//                         </Typography>
//                       )}
//                     </Box>
//                   )}
//                 </Box>
//               </Grid>
//             ))}
//           </Grid>
//         )}
//       </Box>
//       <Box textAlign="center" sx={{ marginTop: 1 }}>
//         <Button
//           variant="contained"
//           sx={{
//             backgroundColor: "#142c54",
//             marginRight: 2,
//             "&:hover": {
//               backgroundColor: "#0f2241",
//             },
//           }}
//           onClick={handleSubmit}
//         >
//           Assign OT
//         </Button>
//       </Box>
//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={3000}
//         onClose={() => setSnackbarOpen(false)}
//         anchorOrigin={{ vertical: "top", horizontal: "center" }}
//       >
//         <Alert
//           onClose={() => setSnackbarOpen(false)}
//           severity={snackbarSeverity}
//           sx={{ width: "100%" }}
//         >
//           {snackbarMessage}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };
// export default AssignOT;





//---------------------------------------------------------2025-12-29-----------------------------------------

// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   Box,
//   CircularProgress,
//   Typography,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Grid,
//   Checkbox,
//   FormControlLabel,
//   Button,
//   Snackbar,
//   Alert,
//   Select,
// } from "@mui/material";
// import HeaderBannerPage from "../components/HeaderBannerPage";
// import { FiChevronUp, FiChevronDown } from "react-icons/fi";
// import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";
// import {
//   fetchOTtimes,
//   assignOT,
//   fetchOTjobAttendance,
//   fetchOTdetails,
// } from "../actions/OTAction";
// import { fetchLocations, assignJob, fetchJobs } from "../actions/AssignAction";
// import { useLocation } from "react-router-dom";

// const Dropdown = ({ label, value, onChange, options, loading }) => (
//   <FormControl fullWidth>
//     <InputLabel sx={{ fontSize: { xs: "0.9rem", sm: "1rem" } }}>
//       {label}
//     </InputLabel>
//     <Select
//       value={value}
//       onChange={onChange}
//       label={label}
//       sx={{
//         fontSize: { xs: "0.85rem", sm: "1rem" },
//         borderRadius: "20px",
//         backgroundColor: "#F0F4F8",
//         boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//         "& .MuiSelect-icon": {
//           color: "#154C79",
//         },
//         "& .MuiOutlinedInput-notchedOutline": {
//           borderColor: "#154C79",
//         },
//       }}
//       MenuProps={{
//         PaperProps: {
//           sx: {
//             maxHeight: 250,
//             overflowY: "auto",
//           },
//         },
//       }}
//     >
//       {loading ? (
//         <MenuItem value="">Loading...</MenuItem>
//       ) : options.length ? (
//         options.map((option, index) => (
//           <MenuItem
//             key={index}
//             value={option.value}
//             sx={{
//               whiteSpace: "normal",
//               wordWrap: "break-word",
//               padding: "7px 16px",
//               fontWeight: "400",
//               fontSize: "14px",
//               lineHeight: "1.5",
//               overflow: "hidden",
//               textOverflow: "ellipsis",
//               "&:hover": {
//                 backgroundColor: "rgba(0, 0, 0, 0.08)",
//               },
//               "&.Mui-selected": {
//                 backgroundColor: "rgba(0, 0, 0, 0.12)",
//               },
//             }}
//           >
//             {option.label}
//           </MenuItem>
//         ))
//       ) : (
//         <MenuItem value="">No options available</MenuItem>
//       )}
//     </Select>
//   </FormControl>
// );

// const AssignOT = () => {
//   const dispatch = useDispatch();
//   const location = useLocation();
//   const getCurrentTime = () => {
//     const now = new Date();
//     return now.toTimeString().split(" ")[0];
//   };
//   const { employeeId, department, role } = location.state || {};
//   const { attendanceItems, loading } = useSelector(
//     (state) => state.otjobAttendance
//   );
//   const { timeSlots, loading: timeSlotLoading } = useSelector(
//     (state) => state.timeSlots || {}
//   );
//   const { locationValue, loading: locationLoading } = useSelector(
//     (state) => state.assignLocation || {}
//   );
//   const { loading: otAssignLoading, error } = useSelector(
//     (state) => state.assignOTpost || {}
//   );
//   const [selectedTimes, setSelectedTimes] = useState("");
//   const [selectedTimeId, setSelectedTimeId] = useState("");
//   const [selectedType, setSelectedType] = useState("");
//   const [filteredTimeSlots, setFilteredTimeSlots] = useState([]);
//   const [selectedAttendance, setSelectedAttendance] = useState({});
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarSeverity, setSnackbarSeverity] = useState("success");
//   const [selectedLocation, setSelectedLocation] = useState(role);
//   const { jobValue, loading: jobLoading } = useSelector(
//     (state) => state.assignJob || {}
//   );
//   const [Jobiwno, setSelectedJobiwno] = useState("");
//   const [selectedJobEmployees, setSelectedJobEmployees] = useState(null);
//   const [showDropdown, setShowDropdown] = useState(null);
//   const [isSubmitAttempted, setIsSubmitAttempted] = useState(false);

//   const handleJobClick = (iwNo, jobId) => {
//     if (showDropdown === iwNo) {
//       setShowDropdown(null);
//     } else {
//       setShowDropdown(iwNo);
//       const date = getTodayDate();
//       dispatch(fetchOTjobAttendance(date, department, selectedLocation, iwNo));
//     }
//   };

//   const fetchAssignedEmployees = (iwNo) => {
//     const employees =
//       attendanceItems?.filter((item) => item.iwNo === iwNo && item.selected) ||
//       [];
//     setSelectedJobEmployees(employees);
//   };

//   const handleLocationChange = (event) =>
//     setSelectedLocation(event.target.value);
//   const handleTypeChange = (event) => setSelectedType(event.target.value);

//   const getTodayDate = () => {
//     const today = new Date();
//     return today.toISOString().split("T")[0];
//   };

//   useEffect(() => {
//     const filteredSlots = timeSlots.filter(
//       (slot) => slot.Type === selectedType
//     );
//     setFilteredTimeSlots(filteredSlots);
//     setSelectedTimes("");
//   }, [selectedType, timeSlots]);

//   useEffect(() => {
//     if (employeeId && department) {
//       const date = getTodayDate();
//       dispatch(fetchJobs(date, employeeId));
//       dispatch(fetchOTtimes());
//       dispatch(fetchLocations(department));
//     }
//   }, [dispatch, role, department, selectedLocation, Jobiwno, employeeId]);

//   const formatTimeTo12Hour = (time) => {
//     const [hours, minutes] = time.split(":");
//     const date = new Date();
//     date.setHours(parseInt(hours, 10));
//     date.setMinutes(parseInt(minutes, 10));
//     return date.toLocaleTimeString("en-US", {
//       hour: "numeric",
//       minute: "2-digit",
//       hour12: true,
//     });
//   };

//   const dropdownOptions = {
//     typeOptions: [...new Set(timeSlots.map((slot) => slot.Type))]
//       .map((type) => ({
//         value: type,
//         label:
//           type === "HSD"
//             ? "Company Holidays and Sunday"
//             : type === "SD"
//             ? "Saturday"
//             : type === "WD"
//             ? "Weekday"
//             : null,
//       }))
//       .filter((option) => option.label !== null),
//     timeSlotOptions: filteredTimeSlots.map((slot) => ({
//       value: `${formatTimeTo12Hour(slot.Intime)} - ${formatTimeTo12Hour(
//         slot.OutTime
//       )}`,
//       label: `${formatTimeTo12Hour(slot.Intime)} - ${formatTimeTo12Hour(
//         slot.OutTime
//       )}`,
//     })),
//     locationOptions: locationValue?.map((location) => ({
//       value: location.location,
//       label: location.locationDescription,
//     })),
//   };

//   const handleTimeChange = (event) => {
//     const selectedTimes = event.target.value;
//     const selectedTimesData = filteredTimeSlots.find(
//       (slot) =>
//         `${formatTimeTo12Hour(slot.Intime)} - ${formatTimeTo12Hour(
//           slot.OutTime
//         )}` === selectedTimes
//     );
//     if (selectedTimesData) {
//       setSelectedTimes(selectedTimes);
//       setSelectedTimeId(selectedTimesData.Id);
//     }
//   };

//   const handleCheckboxChange = (id) => {
//     setSelectedAttendance((prev) => {
//       const updatedState = { ...prev, [id]: !prev[id] };
//       return updatedState;
//     });
//   };


//   // const isCompanyHoliday = (date) => {
//   //   const holidays = [
//   //     "2025-01-01", 
//   //     "2025-12-25", 
//   //   ];
//   //   return holidays.includes(date);
//   // };

  
//   const validateSelectedType = () => {
//     const today = new Date();
//     const dayOfWeek = today.getDay();
//     const todayDate = getTodayDate();

//     if (selectedType === "SD" && dayOfWeek !== 6) {
//       return "Overtime type 'Saturday' can only be assigned on Saturdays.";
//     }
//     if (selectedType === "WD" && (dayOfWeek === 0 || dayOfWeek === 6)) {
//       return "Overtime type 'Weekday' can only be assigned on Monday through Friday.";
//     }
//     if (selectedType === "HSD" && dayOfWeek !== 0 ) {
//       return "Overtime type 'Company Holidays and Sunday' can only be assigned on Sundays or company holidays.";
//     }
//     return null; 
//   };

//   const handleSubmit = () => {
//     const selectedEmpData = attendanceItems.filter(
//       (item) => selectedAttendance[item.id]
//     );

    
//     if (!selectedTimes || !selectedType || selectedEmpData.length === 0) {
//       setSnackbarMessage(
//         "Please select a type, time slot, and at least one employee."
//       );
//       setSnackbarSeverity("error");
//       setSnackbarOpen(true);
//       return;
//     }

    
//     const validationError = validateSelectedType();
//     if (validationError) {
//       setSnackbarMessage(validationError);
//       setSnackbarSeverity("error");
//       setSnackbarOpen(true);
//       return;
//     }

//     const getCurrentTime = () => {
//       const now = new Date();
//       return now.toTimeString().split(" ")[0];
//     };

//     const atttendOtList = selectedEmpData.map((item) => ({
//       serviceNo: item.serviceNo,
//       iwNo: item.iwNo,
//       date: `${getTodayDate()} ${getCurrentTime()}`,
//       Otid: selectedTimeId,
//       CreatedBy: employeeId,
//       location: role,
//       Emp_Location: selectedLocation,
//       HolidayOT_Status: "",
//     }));

//     const postData = {
//       atttendOTList: JSON.stringify(atttendOtList),
//       supervisor: employeeId,
//     };

//     setIsSubmitAttempted(true);
//     dispatch(assignOT(postData));
//     setSelectedType("");
//     setSelectedTimes("");
//     setSelectedLocation(role);
//     setSelectedAttendance({});
//   };

//   useEffect(() => {
//     if (isSubmitAttempted && otAssignLoading === false) {
//       if (error) {
//         setSnackbarMessage(`Error: ${error.message}`);
//         setSnackbarSeverity("error");
//       } else {
//         setSnackbarMessage("Overtime assigned successfully!");
//         setSnackbarSeverity("success");
//       }
//       setSnackbarOpen(true);
//       setIsSubmitAttempted(false);
//     }
//   }, [otAssignLoading, error, isSubmitAttempted]);

//   return (
//     <Box sx={{ padding: 0, maxWidth: "95%", margin: "0 auto" }}>
//       <HeaderBannerPage />
//       <Grid container spacing={2} sx={{ marginBottom: 3 }}>
//         <Grid item xs={12} sm={4}>
//           <Dropdown
//             label="Type"
//             value={selectedType}
//             onChange={handleTypeChange}
//             options={dropdownOptions.typeOptions}
//             loading={timeSlotLoading}
//           />
//         </Grid>
//         <Grid item xs={12} sm={4}>
//           <Dropdown
//             label="Time Slots"
//             value={selectedTimes}
//             onChange={handleTimeChange}
//             options={dropdownOptions.timeSlotOptions}
//             loading={timeSlotLoading}
//           />
//         </Grid>
//         <Grid item xs={12} sm={4}>
//           <Dropdown
//             label="Location"
//             value={selectedLocation}
//             onChange={handleLocationChange}
//             options={dropdownOptions.locationOptions}
//             loading={locationLoading}
//           />
//         </Grid>
//       </Grid>
//       <Box sx={{ marginTop: 1, maxHeight: "450px", overflowY: "auto" }}>
//         {jobLoading ? (
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//               height: "200px",
//             }}
//           >
//             <CircularProgress />
//           </Box>
//         ) : (
//           <Grid container spacing={3}>
//             {jobValue.map((job) => (
//               <Grid item xs={12} sm={6} md={4} key={job.id}>
//                 <Box
//                   onClick={() => handleJobClick(job.iwNo, job.id)}
//                   sx={{
//                     padding: "20px",
//                     borderRadius: "12px",
//                     backgroundColor: "#ffffff",
//                     boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
//                     transition: "transform 0.3s ease, box-shadow 0.3s ease",
//                     cursor: "pointer",
//                     "&:hover": {
//                       transform: "translateY(-5px)",
//                       boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.2)",
//                     },
//                   }}
//                 >
//                   <Typography
//                     sx={{
//                       fontWeight: "600",
//                       fontSize: "14px",
//                       color: "#142C54",
//                       marginBottom: 1,
//                       whiteSpace: "normal",
//                       overflow: "visible",
//                       textOverflow: "clip",
//                       wordBreak: "break-word",
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "center",
//                     }}
//                   >
//                     {job.jobDescription}
//                     {showDropdown === job.iwNo ? (
//                       <FiChevronDown size={20} color="#142C54" />
//                     ) : (
//                       <FiChevronUp size={20} color="#142C54" />
//                     )}
//                   </Typography>

//                   {showDropdown === job.iwNo && (
//                     <Box
//                       sx={{
//                         marginTop: "15px",
//                         padding: "10px",
//                         borderRadius: "8px",
//                         backgroundColor: "#F9F9F9",
//                       }}
//                     >
//                       {attendanceItems?.length > 0 ? (
//                         attendanceItems.map((item) => (
//                           <Box
//                             key={item.id}
//                             sx={{
//                               padding: "12px",
//                               borderRadius: "8px",
//                               backgroundColor: "#fff",
//                               boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.05)",
//                               display: "flex",
//                               alignItems: "center",
//                               marginBottom: "8px",
//                             }}
//                           >
//                             <Box sx={{ flexGrow: 1 }}>
//                               <Typography
//                                 sx={{ fontSize: "16px", fontWeight: "500" }}
//                               >
//                                 {item.EmpName}
//                               </Typography>
//                               <Typography
//                                 sx={{ fontSize: "14px", color: "#6C757D" }}
//                               >
//                                 Service No: {item.serviceNo}
//                               </Typography>
//                             </Box>
//                             <Box
//                               sx={{ textAlign: "right", marginLeft: "auto" }}
//                             >
//                               <Typography
//                                 sx={{ color: "#239B56", fontSize: "14px" }}
//                               >
//                                 {item.inTime || "N/A"}
//                               </Typography>
//                               <Typography
//                                 sx={{ color: "#E74C3C", fontSize: "14px" }}
//                               >
//                                 {item.outTime || "N/A"}
//                               </Typography>
//                             </Box>
//                             <FormControlLabel
//                               control={
//                                 <Checkbox
//                                   checked={!!selectedAttendance[item.id]}
//                                   onChange={(event) => {
//                                     event.stopPropagation();
//                                     handleCheckboxChange(item.id);
//                                   }}
//                                   sx={{ marginLeft: 2 }}
//                                 />
//                               }
//                               onClick={(event) => event.stopPropagation()}
//                               label=""
//                             />
//                           </Box>
//                         ))
//                       ) : (
//                         <Typography
//                           sx={{
//                             fontSize: "14px",
//                             color: "#6C757D",
//                             textAlign: "center",
//                           }}
//                         >
//                           No employees assigned
//                         </Typography>
//                       )}
//                     </Box>
//                   )}
//                 </Box>
//               </Grid>
//             ))}
//           </Grid>
//         )}
//       </Box>
//       <Box textAlign="center" sx={{ marginTop: 1 }}>
//         <Button
//           variant="contained"
//           sx={{
//             backgroundColor: "#142c54",
//             marginRight: 2,
//             "&:hover": {
//               backgroundColor: "#0f2241",
//             },
//           }}
//           onClick={handleSubmit}
//         >
//           Assign OT
//         </Button>
//       </Box>
//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={3000}
//         onClose={() => setSnackbarOpen(false)}
//         anchorOrigin={{ vertical: "top", horizontal: "center" }}
//       >
//         <Alert
//           onClose={() => setSnackbarOpen(false)}
//           severity={snackbarSeverity}
//           sx={{ width: "100%" }}
//         >
//           {snackbarMessage}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default AssignOT;








//---------------------------------------------------------2025-12-30-----------------------------------------


// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   Box,
//   CircularProgress,
//   Typography,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Grid,
//   Checkbox,
//   FormControlLabel,
//   Button,
//   Snackbar,
//   Alert,
//   Select,
//   Chip,
// } from "@mui/material";
// import HeaderBannerPage from "../components/HeaderBannerPage";
// import { FiChevronUp, FiChevronDown } from "react-icons/fi";
// import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";
// import {
//   fetchOTtimes,
//   assignOT,
//   fetchOTjobAttendance,
//   fetchOTdetails,
// } from "../actions/OTAction";
// import { fetchLocations, assignJob, fetchJobs } from "../actions/AssignAction";
// import { useLocation } from "react-router-dom";

// const Dropdown = ({ label, value, onChange, options, loading }) => (
//   <FormControl fullWidth>
//     <InputLabel sx={{ fontSize: { xs: "0.9rem", sm: "1rem" } }}>
//       {label}
//     </InputLabel>
//     <Select
//       value={value}
//       onChange={onChange}
//       label={label}
//       sx={{
//         fontSize: { xs: "0.85rem", sm: "1rem" },
//         borderRadius: "20px",
//         backgroundColor: "#F0F4F8",
//         boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//         "& .MuiSelect-icon": {
//           color: "#154C79",
//         },
//         "& .MuiOutlinedInput-notchedOutline": {
//           borderColor: "#154C79",
//         },
//       }}
//       MenuProps={{
//         PaperProps: {
//           sx: {
//             maxHeight: 250,
//             overflowY: "auto",
//           },
//         },
//       }}
//     >
//       {loading ? (
//         <MenuItem value="">Loading...</MenuItem>
//       ) : options.length ? (
//         options.map((option, index) => (
//           <MenuItem
//             key={index}
//             value={option.value}
//             sx={{
//               whiteSpace: "normal",
//               wordWrap: "break-word",
//               padding: "7px 16px",
//               fontWeight: "400",
//               fontSize: "14px",
//               lineHeight: "1.5",
//               overflow: "hidden",
//               textOverflow: "ellipsis",
//               "&:hover": {
//                 backgroundColor: "rgba(0, 0, 0, 0.08)",
//               },
//               "&.Mui-selected": {
//                 backgroundColor: "rgba(0, 0, 0, 0.12)",
//               },
//             }}
//           >
//             {option.label}
//           </MenuItem>
//         ))
//       ) : (
//         <MenuItem value="">No options available</MenuItem>
//       )}
//     </Select>
//   </FormControl>
// );

// const AssignOT = () => {
//   const dispatch = useDispatch();
//   const location = useLocation();
  
//   const { employeeId, department, role } = location.state || {};
  
//   const { attendanceItems, loading: attendanceLoading } = useSelector(
//     (state) => state.otjobAttendance
//   );
//   const { timeSlots, loading: timeSlotLoading } = useSelector(
//     (state) => state.timeSlots || {}
//   );
//   const { locationValue, loading: locationLoading } = useSelector(
//     (state) => state.assignLocation || {}
//   );
//   const { loading: otAssignLoading, error } = useSelector(
//     (state) => state.assignOTpost || {}
//   );
//   const { jobValue, loading: jobLoading } = useSelector(
//     (state) => state.assignJob || {}
//   );
  
//   const [selectedTimes, setSelectedTimes] = useState("");
//   const [selectedTimeId, setSelectedTimeId] = useState("");
//   const [selectedType, setSelectedType] = useState("");
//   const [filteredTimeSlots, setFilteredTimeSlots] = useState([]);
//   const [selectedAttendance, setSelectedAttendance] = useState({});
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarSeverity, setSnackbarSeverity] = useState("success");
//   const [selectedLocation, setSelectedLocation] = useState(role);
//   const [selectedJobiwno, setSelectedJobiwno] = useState("");
//   const [selectedJobEmployees, setSelectedJobEmployees] = useState(null);
//   const [showDropdown, setShowDropdown] = useState(null);
//   const [isSubmitAttempted, setIsSubmitAttempted] = useState(false);
//   const [alreadyAssignedEmployees, setAlreadyAssignedEmployees] = useState([]);

//   const handleJobClick = (iwNo, jobId) => {
//     if (showDropdown === iwNo) {
//       setShowDropdown(null);
//     } else {
//       setShowDropdown(iwNo);
//       const date = getTodayDate();
//       dispatch(fetchOTjobAttendance(date, department, selectedLocation, iwNo));
//     }
//   };


//   useEffect(() => {
//     if (attendanceItems && attendanceItems.length > 0) {

//       const autoSelected = {};
//       const alreadyAssigned = [];
      
//       attendanceItems.forEach((item) => {
//         if (item.OTstatus === "Y") {
//           autoSelected[item.id] = true;
//           alreadyAssigned.push(item);
//         }
//       });
      
 
//       setSelectedAttendance(prev => ({
//         ...prev,
//         ...autoSelected
//       }));
      
//       setAlreadyAssignedEmployees(alreadyAssigned);
//     }
//   }, [attendanceItems]);

//   const fetchAssignedEmployees = (iwNo) => {
//     const employees =
//       attendanceItems?.filter((item) => item.iwNo === iwNo && item.selected) ||
//       [];
//     setSelectedJobEmployees(employees);
//   };

//   const handleLocationChange = (event) =>
//     setSelectedLocation(event.target.value);
//   const handleTypeChange = (event) => setSelectedType(event.target.value);

//   const getTodayDate = () => {
//     const today = new Date();
//     return today.toISOString().split("T")[0];
//   };

//   useEffect(() => {
//     const filteredSlots = timeSlots.filter(
//       (slot) => slot.Type === selectedType
//     );
//     setFilteredTimeSlots(filteredSlots);
//     setSelectedTimes("");
//   }, [selectedType, timeSlots]);

//   useEffect(() => {
//     if (employeeId && department) {
//       const date = getTodayDate();
//       dispatch(fetchJobs(date, employeeId));
//       dispatch(fetchOTtimes());
//       dispatch(fetchLocations(department));
//     }
//   }, [dispatch, role, department, selectedLocation, selectedJobiwno, employeeId]);

//   const formatTimeTo12Hour = (time) => {
//     const [hours, minutes] = time.split(":");
//     const date = new Date();
//     date.setHours(parseInt(hours, 10));
//     date.setMinutes(parseInt(minutes, 10));
//     return date.toLocaleTimeString("en-US", {
//       hour: "numeric",
//       minute: "2-digit",
//       hour12: true,
//     });
//   };

//   const dropdownOptions = {
//     typeOptions: [...new Set(timeSlots.map((slot) => slot.Type))]
//       .map((type) => ({
//         value: type,
//         label:
//           type === "HSD"
//             ? "Company Holidays and Sunday"
//             : type === "SD"
//             ? "Saturday"
//             : type === "WD"
//             ? "Weekday"
//             : null,
//       }))
//       .filter((option) => option.label !== null),
//     timeSlotOptions: filteredTimeSlots.map((slot) => ({
//       value: `${formatTimeTo12Hour(slot.Intime)} - ${formatTimeTo12Hour(
//         slot.OutTime
//       )}`,
//       label: `${formatTimeTo12Hour(slot.Intime)} - ${formatTimeTo12Hour(
//         slot.OutTime
//       )}`,
//     })),
//     locationOptions: locationValue?.map((location) => ({
//       value: location.location,
//       label: location.locationDescription,
//     })),
//   };

//   const handleTimeChange = (event) => {
//     const selectedTimes = event.target.value;
//     const selectedTimesData = filteredTimeSlots.find(
//       (slot) =>
//         `${formatTimeTo12Hour(slot.Intime)} - ${formatTimeTo12Hour(
//           slot.OutTime
//         )}` === selectedTimes
//     );
//     if (selectedTimesData) {
//       setSelectedTimes(selectedTimes);
//       setSelectedTimeId(selectedTimesData.Id);
//     }
//   };

//   const handleCheckboxChange = (id) => {
//     setSelectedAttendance((prev) => {
//       const updatedState = { ...prev, [id]: !prev[id] };
//       return updatedState;
//     });
//   };

//   const validateSelectedType = () => {
//     const today = new Date();
//     const dayOfWeek = today.getDay();
//     const todayDate = getTodayDate();

//     if (selectedType === "SD" && dayOfWeek !== 6) {
//       return "Overtime type 'Saturday' can only be assigned on Saturdays.";
//     }
//     if (selectedType === "WD" && (dayOfWeek === 0 || dayOfWeek === 6)) {
//       return "Overtime type 'Weekday' can only be assigned on Monday through Friday.";
//     }
//     if (selectedType === "HSD" && dayOfWeek !== 0 ) {
//       return "Overtime type 'Company Holidays and Sunday' can only be assigned on Sundays or company holidays.";
//     }
//     return null; 
//   };

//   const getCurrentTime = () => {
//     const now = new Date();
//     return now.toTimeString().split(" ")[0];
//   };

//   const handleSubmit = () => {
    
//     const selectedEmpData = attendanceItems.filter(
//       (item) => selectedAttendance[item.id] && item.OTstatus !== "Y"
//     );

    
//     const alreadyAssignedCount = attendanceItems.filter(
//       (item) => item.OTstatus === "Y"
//     ).length;

//     if (!selectedTimes || !selectedType || selectedEmpData.length === 0) {
//       let message = "Please select a type, time slot, and at least one employee.";
      
//       if (alreadyAssignedCount > 0) {
//         message += ` Note: ${alreadyAssignedCount} employee(s) already have OT assigned and are automatically selected.`;
//       }
      
//       setSnackbarMessage(message);
//       setSnackbarSeverity("error");
//       setSnackbarOpen(true);
//       return;
//     }

//     const validationError = validateSelectedType();
//     if (validationError) {
//       setSnackbarMessage(validationError);
//       setSnackbarSeverity("error");
//       setSnackbarOpen(true);
//       return;
//     }

//     const atttendOtList = selectedEmpData.map((item) => ({
//       serviceNo: item.serviceNo,
//       iwNo: item.iwNo,
//       date: `${getTodayDate()} ${getCurrentTime()}`,
//       Otid: selectedTimeId,
//       CreatedBy: employeeId,
//       location: role,
//       Emp_Location: selectedLocation,
//       HolidayOT_Status: "",
//     }));
//     console.log("Attend OT List:", atttendOtList);
//     const postData = {
//       atttendOTList: JSON.stringify(atttendOtList),
//       supervisor: employeeId,
//     };

//     setIsSubmitAttempted(true);
//     dispatch(assignOT(postData));
//     setSelectedType("");
//     setSelectedTimes("");
//     setSelectedLocation(role);
//     setSelectedAttendance({});
//     setAlreadyAssignedEmployees([]);
//   };

//   useEffect(() => {
//     if (isSubmitAttempted && otAssignLoading === false) {
//       if (error) {
//         setSnackbarMessage(`Error: ${error.message}`);
//         setSnackbarSeverity("error");
//       } else {
//         const newCount = selectedAttendance ? 
//           Object.keys(selectedAttendance).filter(id => {
//             const item = attendanceItems?.find(i => i.id === parseInt(id));
//             return item && item.OTstatus !== "Y";
//           }).length : 0;
        
//         setSnackbarMessage(`Overtime assigned successfully to ${newCount} employee(s)!`);
//         setSnackbarSeverity("success");
//       }
//       setSnackbarOpen(true);
//       setIsSubmitAttempted(false);
//     }
//   }, [otAssignLoading, error, isSubmitAttempted, selectedAttendance, attendanceItems]);

//   return (
//     <Box sx={{ padding: 0, maxWidth: "95%", margin: "0 auto" }}>
//       <HeaderBannerPage />
      
//       {/* Information Banner */}
      
      
//       <Grid container spacing={2} sx={{ marginBottom: 3 }}>
//         <Grid item xs={12} sm={4}>
//           <Dropdown
//             label="Type"
//             value={selectedType}
//             onChange={handleTypeChange}
//             options={dropdownOptions.typeOptions}
//             loading={timeSlotLoading}
//           />
//         </Grid>
//         <Grid item xs={12} sm={4}>
//           <Dropdown
//             label="Time Slots"
//             value={selectedTimes}
//             onChange={handleTimeChange}
//             options={dropdownOptions.timeSlotOptions}
//             loading={timeSlotLoading}
//           />
//         </Grid>
//         <Grid item xs={12} sm={4}>
//           <Dropdown
//             label="Location"
//             value={selectedLocation}
//             onChange={handleLocationChange}
//             options={dropdownOptions.locationOptions}
//             loading={locationLoading}
//           />
//         </Grid>
//       </Grid>
      
//       <Box sx={{ marginTop: 1, maxHeight: "450px", overflowY: "auto" }}>
//         {jobLoading ? (
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//               height: "200px",
//             }}
//           >
//             <CircularProgress />
//           </Box>
//         ) : (
//           <Grid container spacing={3}>
//             {jobValue.map((job) => (
//               <Grid item xs={12} sm={6} md={4} key={job.id}>
//                 <Box
//                   onClick={() => handleJobClick(job.iwNo, job.id)}
//                   sx={{
//                     padding: "20px",
//                     borderRadius: "12px",
//                     backgroundColor: "#ffffff",
//                     boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
//                     transition: "transform 0.3s ease, box-shadow 0.3s ease",
//                     cursor: "pointer",
//                     "&:hover": {
//                       transform: "translateY(-5px)",
//                       boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.2)",
//                     },
//                   }}
//                 >
//                   <Typography
//                     sx={{
//                       fontWeight: "600",
//                       fontSize: "14px",
//                       color: "#142C54",
//                       marginBottom: 1,
//                       whiteSpace: "normal",
//                       overflow: "visible",
//                       textOverflow: "clip",
//                       wordBreak: "break-word",
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "center",
//                     }}
//                   >
//                     {job.jobDescription}
//                     {showDropdown === job.iwNo ? (
//                       <FiChevronDown size={20} color="#142C54" />
//                     ) : (
//                       <FiChevronUp size={20} color="#142C54" />
//                     )}
//                   </Typography>

//                   {showDropdown === job.iwNo && (
//                     <Box
//                       sx={{
//                         marginTop: "15px",
//                         padding: "10px",
//                         borderRadius: "8px",
//                         backgroundColor: "#F9F9F9",
//                       }}
//                     >
//                       {attendanceLoading ? (
//                         <Box sx={{ display: "flex", justifyContent: "center", padding: "20px" }}>
//                           <CircularProgress size={30} />
//                         </Box>
//                       ) : attendanceItems?.length > 0 ? (
//                         <>
//                           <Box sx={{ marginBottom: 2 }}>
//                             <Typography variant="body2" sx={{ color: "#666", fontStyle: "italic" }}>
//                               Employees with OT already assigned are automatically selected
//                             </Typography>
//                           </Box>
                          
//                           {attendanceItems.map((item) => (
//                             <Box
//                               key={item.id}
//                               sx={{
//                                 padding: "12px",
//                                 borderRadius: "8px",
//                                 backgroundColor: item.OTstatus === "Y" ? "#f0f9ff" : "#fff",
//                                 boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.05)",
//                                 display: "flex",
//                                 alignItems: "center",
//                                 marginBottom: "8px",
//                                 border: item.OTstatus === "Y" ? "1px solid #90caf9" : "none",
//                                 position: "relative",
//                               }}
//                             >
//                               {item.OTstatus === "Y" && (
//                                 <Chip
//                                   label="OT Assigned"
//                                   size="small"
//                                   sx={{
//                                     position: "absolute",
//                                     top: "-8px",
//                                     right: "10px",
//                                     backgroundColor: "#4caf50",
//                                     color: "white",
//                                     fontSize: "10px",
//                                     height: "18px",
//                                     "& .MuiChip-label": {
//                                       padding: "0 6px",
//                                     },
//                                   }}
//                                 />
//                               )}
                              
//                               <Box sx={{ flexGrow: 1 }}>
//                                 <Typography
//                                   sx={{ 
//                                     fontSize: "16px", 
//                                     fontWeight: "500",
//                                     color: item.OTstatus === "Y" ? "#1976d2" : "inherit"
//                                   }}
//                                 >
//                                   {item.EmpName}
//                                 </Typography>
//                                 <Typography
//                                   sx={{ fontSize: "14px", color: "#6C757D" }}
//                                 >
//                                   Service No: {item.serviceNo}
//                                 </Typography>
//                               </Box>
//                               <Box
//                                 sx={{ textAlign: "right", marginLeft: "auto" }}
//                               >
//                                 <Typography
//                                   sx={{ color: "#239B56", fontSize: "14px" }}
//                                 >
//                                   {item.inTime || "N/A"}
//                                 </Typography>
//                                 <Typography
//                                   sx={{ color: "#E74C3C", fontSize: "14px" }}
//                                 >
//                                   {item.outTime || "N/A"}
//                                 </Typography>
//                               </Box>
//                               <FormControlLabel
//                                 control={
//                                   <Checkbox
//                                     checked={!!selectedAttendance[item.id]}
//                                     onChange={(event) => {
//                                       event.stopPropagation();
//                                       if (item.OTstatus !== "Y") {
//                                         handleCheckboxChange(item.id);
//                                       }
//                                     }}
//                                     disabled={item.OTstatus === "Y"}
//                                     sx={{ 
//                                       marginLeft: 2,
//                                       '&.Mui-disabled': {
//                                         color: '#4caf50',
//                                       }
//                                     }}
//                                   />
//                                 }
//                                 onClick={(event) => {
//                                   event.stopPropagation();
//                                   if (item.OTstatus === "Y") {
//                                     event.preventDefault();
//                                   }
//                                 }}
//                                 label=""
//                               />
//                             </Box>
//                           ))}
                          
                        
//                         </>
//                       ) : (
//                         <Typography
//                           sx={{
//                             fontSize: "14px",
//                             color: "#6C757D",
//                             textAlign: "center",
//                           }}
//                         >
//                           No employees assigned
//                         </Typography>
//                       )}
//                     </Box>
//                   )}
//                 </Box>
//               </Grid>
//             ))}
//           </Grid>
//         )}
//       </Box>

//       <Box textAlign="center" sx={{ marginTop: 1 }}>
//         <Button
//           variant="contained"
//           sx={{
//             backgroundColor: "#142c54",
//             marginRight: 2,
//             "&:hover": {
//               backgroundColor: "#0f2241",
//             },
//           }}
//           onClick={handleSubmit}
//         >
//           Assign OT
//         </Button>
//       </Box>
      
//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={4000}
//         onClose={() => setSnackbarOpen(false)}
//         anchorOrigin={{ vertical: "top", horizontal: "center" }}
//       >
//         <Alert
//           onClose={() => setSnackbarOpen(false)}
//           severity={snackbarSeverity}
//           sx={{ width: "100%" }}
//         >
//           {snackbarMessage}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default AssignOT;








import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  CircularProgress,
  Typography,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
  Checkbox,
  FormControlLabel,
  Button,
  Snackbar,
  Alert,
  Select,
  Chip,
} from "@mui/material";
import HeaderBannerPage from "../components/HeaderBannerPage";
import { FiChevronUp, FiChevronDown } from "react-icons/fi";
import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";
import {
  fetchOTtimes,
  assignOT,
  fetchOTjobAttendance,
  fetchOTdetails,
} from "../actions/OTAction";
import { fetchLocations, assignJob, fetchJobs } from "../actions/AssignAction";
import { useLocation } from "react-router-dom";

const Dropdown = ({ label, value, onChange, options, loading }) => (
  <FormControl fullWidth>
    <InputLabel sx={{ fontSize: { xs: "0.9rem", sm: "1rem" } }}>
      {label}
    </InputLabel>
    <Select
      value={value}
      onChange={onChange}
      label={label}
      sx={{
        fontSize: { xs: "0.85rem", sm: "1rem" },
        borderRadius: "20px",
        backgroundColor: "#F0F4F8",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        "& .MuiSelect-icon": {
          color: "#154C79",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "#154C79",
        },
      }}
      MenuProps={{
        PaperProps: {
          sx: {
            maxHeight: 250,
            overflowY: "auto",
          },
        },
      }}
    >
      {loading ? (
        <MenuItem value="">Loading...</MenuItem>
      ) : options.length ? (
        options.map((option, index) => (
          <MenuItem
            key={index}
            value={option.value}
            sx={{
              whiteSpace: "normal",
              wordWrap: "break-word",
              padding: "7px 16px",
              fontWeight: "400",
              fontSize: "14px",
              lineHeight: "1.5",
              overflow: "hidden",
              textOverflow: "ellipsis",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.08)",
              },
              "&.Mui-selected": {
                backgroundColor: "rgba(0, 0, 0, 0.12)",
              },
            }}
          >
            {option.label}
          </MenuItem>
        ))
      ) : (
        <MenuItem value="">No options available</MenuItem>
      )}
    </Select>
  </FormControl>
);

const AssignOT = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const { employeeId, department, role } = location.state || {};

  const { attendanceItems, loading: attendanceLoading } = useSelector(
    (state) => state.otjobAttendance
  );
  const { timeSlots, loading: timeSlotLoading } = useSelector(
    (state) => state.timeSlots || {}
  );
  const { locationValue, loading: locationLoading } = useSelector(
    (state) => state.assignLocation || {}
  );
  const { loading: otAssignLoading, error } = useSelector(
    (state) => state.assignOTpost || {}
  );
  const { jobValue, loading: jobLoading } = useSelector(
    (state) => state.assignJob || {}
  );

  const [selectedTimes, setSelectedTimes] = useState("");
  const [selectedTimeId, setSelectedTimeId] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [filteredTimeSlots, setFilteredTimeSlots] = useState([]);
  const [selectedAttendance, setSelectedAttendance] = useState({});
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [selectedLocation, setSelectedLocation] = useState(role);
  const [selectedJobiwno, setSelectedJobiwno] = useState("");
  const [selectedJobEmployees, setSelectedJobEmployees] = useState(null);
  const [showDropdown, setShowDropdown] = useState(null);
  const [isSubmitAttempted, setIsSubmitAttempted] = useState(false);
  const [alreadyAssignedEmployees, setAlreadyAssignedEmployees] = useState([]);
  const [activeIwNo, setActiveIwNo] = useState(null);

  const handleJobClick = (iwNo, jobId) => {
    if (showDropdown === iwNo) {
      setShowDropdown(null);
    } else {
      setShowDropdown(iwNo);
      setActiveIwNo(iwNo);
      const date = getTodayDate();
      dispatch(fetchOTjobAttendance(date, department, selectedLocation, iwNo));
    }
  };


  // useEffect(() => {
  //   if (attendanceItems && attendanceItems.length > 0) {

  //     const autoSelected = {};
  //     const alreadyAssigned = [];

  //     attendanceItems.forEach((item) => {
  //       if (item.OTstatus === "Y") {
  //         autoSelected[item.id] = true;
  //         alreadyAssigned.push(item);
  //       }
  //     });


  //     setSelectedAttendance(prev => ({
  //       ...prev,
  //       ...autoSelected
  //     }));

  //     setAlreadyAssignedEmployees(alreadyAssigned);
  //   }
  // }, [attendanceItems]);


  useEffect(() => {
    if (attendanceItems && attendanceItems.length > 0) {
      const alreadyAssigned = [];

      attendanceItems.forEach((item) => {
        if (item.OTstatus === "Y") {
          alreadyAssigned.push(item);
        }
      });


      setAlreadyAssignedEmployees(alreadyAssigned);

    }
  }, [attendanceItems]);


  const fetchAssignedEmployees = (iwNo) => {
    const employees =
      attendanceItems?.filter((item) => item.iwNo === iwNo && item.selected) ||
      [];
    setSelectedJobEmployees(employees);
  };

  const handleLocationChange = (event) =>
    setSelectedLocation(event.target.value);
  const handleTypeChange = (event) => setSelectedType(event.target.value);

  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };

  useEffect(() => {
    const filteredSlots = timeSlots.filter(
      (slot) => slot.Type === selectedType
    );
    setFilteredTimeSlots(filteredSlots);
    setSelectedTimes("");
  }, [selectedType, timeSlots]);

  useEffect(() => {
    if (employeeId && department) {
      const date = getTodayDate();
      dispatch(fetchJobs(date, employeeId));
      dispatch(fetchOTtimes());
      dispatch(fetchLocations(department));
    }
  }, [dispatch, role, department, selectedLocation, selectedJobiwno, employeeId]);

  const formatTimeTo12Hour = (time) => {
    const [hours, minutes] = time.split(":");
    const date = new Date();
    date.setHours(parseInt(hours, 10));
    date.setMinutes(parseInt(minutes, 10));
    return date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  const dropdownOptions = {
    typeOptions: [...new Set(timeSlots.map((slot) => slot.Type))]
      .map((type) => ({
        value: type,
        label:
          type === "HSD"
            ? "Company Holidays and Sunday"
            : type === "SD"
              ? "Saturday"
              : type === "WD"
                ? "Weekday"
                : null,
      }))
      .filter((option) => option.label !== null),
    timeSlotOptions: filteredTimeSlots.map((slot) => ({
      value: `${formatTimeTo12Hour(slot.Intime)} - ${formatTimeTo12Hour(
        slot.OutTime
      )}`,
      label: `${formatTimeTo12Hour(slot.Intime)} - ${formatTimeTo12Hour(
        slot.OutTime
      )}`,
    })),
    locationOptions: locationValue?.map((location) => ({
      value: location.location,
      label: location.locationDescription,
    })),
  };

  const handleTimeChange = (event) => {
    const selectedTimes = event.target.value;
    const selectedTimesData = filteredTimeSlots.find(
      (slot) =>
        `${formatTimeTo12Hour(slot.Intime)} - ${formatTimeTo12Hour(
          slot.OutTime
        )}` === selectedTimes
    );
    if (selectedTimesData) {
      setSelectedTimes(selectedTimes);
      setSelectedTimeId(selectedTimesData.Id);
    }
  };

  const handleCheckboxChange = (id) => {
    setSelectedAttendance((prev) => {
      const updatedState = { ...prev, [id]: !prev[id] };
      return updatedState;
    });
  };

  const validateSelectedType = () => {
    const today = new Date();
    const dayOfWeek = today.getDay();
    const todayDate = getTodayDate();

    if (selectedType === "SD" && dayOfWeek !== 6) {
      return "Overtime type 'Saturday' can only be assigned on Saturdays.";
    }
    if (selectedType === "WD" && (dayOfWeek === 0 || dayOfWeek === 6)) {
      return "Overtime type 'Weekday' can only be assigned on Monday through Friday.";
    }
    if (selectedType === "HSD" && dayOfWeek !== 0) {
      return "Overtime type 'Company Holidays and Sunday' can only be assigned on Sundays or company holidays.";
    }
    return null;
  };

  const getCurrentTime = () => {
    const now = new Date();
    return now.toTimeString().split(" ")[0];
  };

  const handleSubmit = () => {

    // const selectedEmpData = attendanceItems.filter(
    //   (item) => selectedAttendance[item.id] && item.OTstatus !== "Y"
    // );

    const selectedEmpData = attendanceItems.filter(
      (item) => selectedAttendance[item.id]
    );



    const alreadyAssignedCount = attendanceItems.filter(
      (item) => item.OTstatus === "Y"
    ).length;

    // if (!selectedTimes || !selectedType || selectedEmpData.length === 0) {
    //   let message = "Please select a type, time slot, and at least one employee.";

    //   if (alreadyAssignedCount > 0) {
    //     message += ` Note: ${alreadyAssignedCount} employee(s) already have OT assigned and are automatically selected.`;
    //   }

    //   setSnackbarMessage(message);
    //   setSnackbarSeverity("error");
    //   setSnackbarOpen(true);
    //   return;
    // }

    const validationError = validateSelectedType();
    if (validationError) {
      setSnackbarMessage(validationError);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    const atttendOtList = selectedEmpData.map((item) => ({
      serviceNo: item.serviceNo,
      iwNo: item.iwNo,
      date: `${getTodayDate()} ${getCurrentTime()}`,
      Otid: selectedTimeId,
      CreatedBy: employeeId,
      location: role,
      Emp_Location: selectedLocation,
      HolidayOT_Status: "",
    }));
    console.log("Attend OT List:", atttendOtList);
    const postData = {
      atttendOTList: JSON.stringify(atttendOtList),
      supervisor: employeeId,
    };

    setIsSubmitAttempted(true);
    dispatch(assignOT(postData));
    setSelectedType("");
    setSelectedTimes("");
    setSelectedLocation(role);
    setSelectedAttendance({});
    setAlreadyAssignedEmployees([]);
  };

  useEffect(() => {
    if (isSubmitAttempted && otAssignLoading === false) {
      if (error) {
        setSnackbarMessage(`Error: ${error.message}`);
        setSnackbarSeverity("error");
      } else {
        const newCount = selectedAttendance ?
          Object.keys(selectedAttendance).filter(id => {
            const item = attendanceItems?.find(i => i.id === parseInt(id));
            return item && item.OTstatus !== "Y";
          }).length : 0;

        setSnackbarMessage(`Overtime assigned successfully `);
        setSnackbarSeverity("success");

        if (activeIwNo) {
          const date = getTodayDate();
          dispatch(
            fetchOTjobAttendance(date, department, selectedLocation, activeIwNo)
          );
        }

      }
      setSnackbarOpen(true);
      setIsSubmitAttempted(false);
    }
  }, [otAssignLoading, error, isSubmitAttempted, selectedAttendance, attendanceItems]);

  return (
    <Box sx={{ padding: 0, maxWidth: "95%", margin: "0 auto" }}>
      <HeaderBannerPage />

      {/* Information Banner */}


      <Grid container spacing={2} sx={{ marginBottom: 3 }}>
        <Grid item xs={12} sm={4}>
          <Dropdown
            label="Type"
            value={selectedType}
            onChange={handleTypeChange}
            options={dropdownOptions.typeOptions}
            loading={timeSlotLoading}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Dropdown
            label="Time Slots"
            value={selectedTimes}
            onChange={handleTimeChange}
            options={dropdownOptions.timeSlotOptions}
            loading={timeSlotLoading}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Dropdown
            label="Location"
            value={selectedLocation}
            onChange={handleLocationChange}
            options={dropdownOptions.locationOptions}
            loading={locationLoading}
          />
        </Grid>
      </Grid>

      <Box sx={{ marginTop: 1, maxHeight: "450px", overflowY: "auto" }}>
        {jobLoading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "200px",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Grid container spacing={3}>
            {jobValue.map((job) => (
              <Grid item xs={12} sm={6} md={4} key={job.id}>
                <Box
                  onClick={() => handleJobClick(job.iwNo, job.id)}
                  sx={{
                    padding: "20px",
                    borderRadius: "12px",
                    backgroundColor: "#ffffff",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    cursor: "pointer",
                    "&:hover": {
                      transform: "translateY(-5px)",
                      boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.2)",
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "600",
                      fontSize: "14px",
                      color: "#142C54",
                      marginBottom: 1,
                      whiteSpace: "normal",
                      overflow: "visible",
                      textOverflow: "clip",
                      wordBreak: "break-word",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    {job.jobDescription}
                    {showDropdown === job.iwNo ? (
                      <FiChevronDown size={20} color="#142C54" />
                    ) : (
                      <FiChevronUp size={20} color="#142C54" />
                    )}
                  </Typography>

                  {showDropdown === job.iwNo && (
                    <Box
                      sx={{
                        marginTop: "15px",
                        padding: "10px",
                        borderRadius: "8px",
                        backgroundColor: "#F9F9F9",
                      }}
                    >
                      {attendanceLoading ? (
                        <Box sx={{ display: "flex", justifyContent: "center", padding: "20px" }}>
                          <CircularProgress size={30} />
                        </Box>
                      ) : attendanceItems?.length > 0 ? (
                        <>

                          {attendanceItems.map((item) => (
                            <Box
                              key={item.id}
                              sx={{
                                padding: "12px",
                                borderRadius: "8px",
                                backgroundColor: item.OTstatus === "Y" ? "#f0f9ff" : "#fff",
                                boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.05)",
                                display: "flex",
                                alignItems: "center",
                                marginBottom: "8px",
                                border: item.OTstatus === "Y" ? "1px solid #90caf9" : "none",
                                position: "relative",
                              }}
                            >
                              {item.OTstatus === "Y" && (
                                <Chip
                                  label="OT Assigned"
                                  size="small"
                                  sx={{
                                    position: "absolute",
                                    top: "-8px",
                                    right: "10px",
                                    backgroundColor: "#4caf50",
                                    color: "white",
                                    fontSize: "10px",
                                    height: "18px",
                                    "& .MuiChip-label": {
                                      padding: "0 6px",
                                    },
                                  }}
                                />
                              )}

                              <Box sx={{ flexGrow: 1 }}>
                                <Typography
                                  sx={{
                                    fontSize: "16px",
                                    fontWeight: "500",
                                    color: item.OTstatus === "Y" ? "#1976d2" : "inherit"
                                  }}
                                >
                                  {item.EmpName}
                                </Typography>
                                <Typography
                                  sx={{ fontSize: "14px", color: "#6C757D" }}
                                >
                                  Service No: {item.serviceNo}
                                </Typography>
                              </Box>
                              <Box
                                sx={{ textAlign: "right", marginLeft: "auto" }}
                              >
                                <Typography
                                  sx={{ color: "#239B56", fontSize: "14px" }}
                                >
                                  {item.inTime || "N/A"}
                                </Typography>
                                <Typography
                                  sx={{ color: "#E74C3C", fontSize: "14px" }}
                                >
                                  {item.outTime || "N/A"}
                                </Typography>
                              </Box>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={!!selectedAttendance[item.id]}
                                    onChange={(event) => {
                                      event.stopPropagation();
                                      handleCheckboxChange(item.id);
                                    }}
                                  />

                                }
                                onClick={(event) => {
                                  event.stopPropagation();

                                }}
                                label=""
                              />
                            </Box>
                          ))}


                        </>
                      ) : (
                        <Typography
                          sx={{
                            fontSize: "14px",
                            color: "#6C757D",
                            textAlign: "center",
                          }}
                        >
                          No employees assigned
                        </Typography>
                      )}
                    </Box>
                  )}
                </Box>
              </Grid>
            ))}
          </Grid>
        )}
      </Box>

      <Box textAlign="center" sx={{ marginTop: 1 }}>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#142c54",
            marginRight: 2,
            "&:hover": {
              backgroundColor: "#0f2241",
            },
          }}
          onClick={handleSubmit}
        >
          Assign OT
        </Button>
      </Box>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default AssignOT;
